
export interface InterpolationOptions {
  decimalPlaces?: number;
  recursive?: boolean;
}

// @dynamic
export class InterpolationService{
  static templateMatcher: RegExp = /{{\s?([^{}\s]*)\s?}}/g;
  private static isDefined(val:any){
    return val!==undefined && val!==null;
  }

  public static interpolate(expr: string, params?: any, options?: InterpolationOptions): string {
    if(typeof expr !== 'string' || !params) {
      return expr;
    }

    return expr.replace(InterpolationService.templateMatcher, (substring: string, b: string) => {
      let r = InterpolationService.getFormatted(params, b,options);
      return InterpolationService.isDefined(r) ? r : substring;
    });
  }

  static getFormatted(target: any, key: string, options?: InterpolationOptions): string {
    const val = InterpolationService.getValue(target, key);
    if(options?.decimalPlaces !== undefined && typeof val === 'number') {
      return (val as number).toFixed(options.decimalPlaces);
    }
    if(options?.recursive && typeof val === 'string' && val.match(InterpolationService.templateMatcher)) {
      return InterpolationService.interpolate(val, target, options);
    }
    return val;
  }

  static getValue(target: any, key: string): string {
    let keys = key.split('.');
    key = '';
    do {
      key += keys.shift();
      if(InterpolationService.isDefined(target) && InterpolationService.isDefined(target[key]) && (typeof target[key] === 'object' || !keys.length)) {
        target = target[key];
        key = '';
      } else if(!keys.length) {
        target = undefined;
      } else {
        key += '.';
      }
    } while(keys.length);

    return target;
  }

  static interpolateAll(params: any, subs: any): any {
    const result: any = {};
    Object.keys(params).forEach(k => {
      if (typeof (k) === 'string') {
        result[k] = InterpolationService.interpolate(params[k], subs);
      } else {
        result[k] = params[k];
      }
    });

    return result;
  }
}
